import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const pageMapping = {
  SCRR411102: "JOB-35",
  SCRR410028: "JOB-39",
  SCRR411119: "JOB-40",
  SCRR410003: "JOB-41",
  SCRC070206: "JOB-44",
  SCRC060134: "JOB-47",
};

const schema = {
  required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  pattern: {
    value: /^[a-zA-Z0-9]+$/,
    message: TkPropertyMessageGet("TKMSG_SCR0093E"),
  },
  maxLength: {
    value: 6,
    message: TkPropertyMessageGet("TKMSG_SCR0046E", "6"),
  },
};

export { pageMapping, schema };
